<template>
     <video-player  class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
        ></video-player>
</template>

<script>
export default {
  name: 'BusImg',
  data () {
    return {
      // 视频播放
      playerOptions : {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "",
          src: 'http://wkds1.fxiang.cn/1006%20%5BAVC%20720p%5D.mp4'//url地址          
          // src: "" //url地址
        }],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
    }
    }
  },
  methods: {
      getOrderNo(){
      var orderNo = sessionStorage.getItem('orderNo');
      console.log("orderNo:",orderNo)
      this.$axios.get(
            "http://ysj.fxiang.cn/wxPay/getOrderNo/",
            {params:{
                orderNo:orderNo,
              }}
            ).then(function(resp){
              console.log("声明结果1111:"+resp)
          },function(err){
            console.log("失败1111")
          })
    },
  },
   mounted () { //这个属性就可以，在里面声明初始化时要调用的方法即可
      // we can implement any method here like
      // this.getOrderNo()
    }
}
</script>
